module.exports = __webpack_public_path__ + "img/shenzhen.a6a27959.jpg";